import * as player from '../player.js';
import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as audio from '../audio.js';
import { Tween } from '../tweens.js'

export {
    init,
}

let chameauSound;

const POIs = [
    {
        name: 'chameau',
        position: { x: 22, y: 18, z: 0 },
        color: '#7f5d49',
        radius: 5,
        sound: {
            name: 'chameau-idle',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
        collision: {
            radius: 1,
        },
        async onEnter() {
            // Follow player
            this.sound.source.fadeTo(1, -90, -12);
            chameauSound = await audio.buffers.play('chameau', {
                loop: true,
                gain: 0,
            });

            player.config.maxVelocity = 1.5;

            const originalPosition = { ...this.position };
            new Tween(this.position, player.position, 1, 'easeOutQuad', (v) => {
                this.sound.panner.positionPanner(v.x, v.z, v.y);
            }, (tween) => {
                setTimeout(() => {
                    this.sound.source.fadeTo(1, -12, -90);
                    // Manual cleanup to stop following player
                    tween.dispose();
                    chameauSound.fade();
                    new Tween(this.position, originalPosition, 4, 'easeInOutQuad', (v) => {
                        this.sound.panner.positionPanner(v.x, v.z, v.y);
                    });
                    new Tween(12, 5, 2, 'easeOutQuad', (v) => {
                        this.radius = v;
                    });

                    player.config.maxVelocity = 2.5;
                }, 10000);
            });
            // Increase radius to 15
            new Tween(this.radius, 12, 0.5, 'easeOutQuad', (v) => {
                this.radius = v;
            });
        },
    },
];

const sounds = [
    { name: 'chameau-idle', url: new URL('../../sound/Chameau_Pause.wav', import.meta.url) },
    { name: 'chameau', url: new URL('../../sound/Chameau.wav', import.meta.url) },
];

const images = [
];

function init() {
    scene.addPOIs(POIs);
    //loader.addImages(images);
    loader.addSounds(sounds);
};
